import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router";
import { talkBrand } from "../lib/brand";
import { ui } from "../lib/ui";
import { postEmbed } from "../lib/embedBridge";
import { EmbedPage } from "../pages/EmbedPage";
import { LoginPage } from "../features/auth/LoginPage";
import { RegisterPage } from "../features/auth/RegisterPage";
import { MeetingPage } from "../features/room/MeetingPage";
import { HistoryPage } from "../pages/HistoryPage";
import { HomePage } from "../pages/HomePage";
import { JoinPage } from "../pages/JoinPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { PrejoinPage } from "../pages/PrejoinPage";
import { SchedulePage } from "../pages/SchedulePage";
import { SettingsPage } from "../pages/SettingsPage";

type InstallPromptEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: "accepted" | "dismissed" }> };

function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState<InstallPromptEvent | null>(null);
  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    const onInstallPrompt = (event: Event) => {
      event.preventDefault();
      setInstallEvent(event as InstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", onInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onInstallPrompt);
  }, []);
  if (!installEvent) return null;
  const install = async () => {
    await installEvent.prompt();
    await installEvent.userChoice;
    setInstallEvent(null);
  };
  return <aside className="install-prompt" role="status"><div><strong>{ui("Keep Talk on your phone", "Оставить OnlyChess на телефоне")}</strong><span>{ui("Install it for a faster return to rooms and better background handoff.", "Установите, чтобы быстрее возвращаться в комнату и сворачивать звонок.")}</span></div><button type="button" className="button button--primary button--small" onClick={() => void install()}>{ui("Install", "Установить")}</button><button type="button" className="install-prompt__dismiss" aria-label={ui("Dismiss install suggestion", "Закрыть предложение")} onClick={() => setInstallEvent(null)}>×</button></aside>;
}

function EmbedBridge() {
  const location = useLocation();
  useEffect(() => {
    if (talkBrand.id !== "chess") return;
    postEmbed({ type: "navigation", path: `${location.pathname}${location.search}` });
  }, [location.pathname, location.search]);
  return null;
}

export function App() {
  return <><EmbedBridge /><InstallPrompt /><Routes><Route path="/" element={<HomePage />} /><Route path="/join" element={<JoinPage />} /><Route path="/embed" element={<EmbedPage />} /><Route path="/schedule" element={<SchedulePage />} /><Route path="/register" element={<RegisterPage />} /><Route path="/login" element={<LoginPage />} /><Route path="/r/:roomId/prejoin" element={<PrejoinPage />} /><Route path="/r/:roomId" element={<MeetingPage />} /><Route path="/history" element={<HistoryPage />} /><Route path="/settings" element={<SettingsPage />} /><Route path="*" element={<NotFoundPage />} /></Routes></>;
}
